var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaldoRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#8FEFB7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3431 28.5V28.8525H13.3861V28.5H14.3431Z",
    fill: "#27AE60",
    stroke: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8628 28.5V28.8525H27.9058V28.5H28.8628Z",
    fill: "#27AE60",
    stroke: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0392 26.1957H12.0321C11.4983 26.1957 11.0356 25.7687 11.0356 25.1993V17.1922C11.0356 16.6584 11.4627 16.1957 12.0321 16.1957H30.0392C30.573 16.1957 31.0356 16.6228 31.0356 17.1922V25.2349C31.0356 25.7687 30.573 26.1957 30.0392 26.1957Z",
    stroke: "#27AE60",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2775 18.1192H23.0284C23.1935 18.1192 23.3467 18.2651 23.3468 18.4376V24.0245C23.3468 24.161 23.2295 24.3077 23.0284 24.3077H13.2775C13.1124 24.3076 12.9591 24.1618 12.9591 23.9893V18.4376C12.9592 18.2726 13.1051 18.1193 13.2775 18.1192Z",
    stroke: "#27AE60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.548 20.0765C28.2545 20.0765 28.8272 20.6493 28.8273 21.3558C28.8273 22.0624 28.2545 22.6351 27.548 22.6351C26.8414 22.6351 26.2687 22.0624 26.2687 21.3558C26.2687 20.6493 26.8415 20.0765 27.548 20.0765Z",
    stroke: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaldoRound);
export default __webpack_public_path__ + "static/media/saldo-round.d45c08c4848044bdf7f8f22b85642047.svg";
export { ForwardRef as ReactComponent };